import React from 'react';
import styled from '@emotion/styled';
import parse, { Element } from 'html-react-parser';
import { omit } from 'lodash';

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
`;

export type EmbedProps = {
  html?: string;
};

const IFrameSafe = (props: Record<string, unknown>) => {
  const safeAttributes = omit(props, ['style']);

  return <IFrame {...safeAttributes} frameBorder='0' />;
};

export default function Embed({ html = '' }: EmbedProps) {
  const defaultSandbox =
    'allow-scripts allow-orientation-lock allow-forms allow-top-navigation-by-user-activation';
  const options = {
    // eslint-disable-next-line react/display-name
    replace: ({ attribs, children, parent }: Element) => {
      if (!attribs || parent !== null) {
        return;
      }

      const iframes = (children as Element[]).filter(
        (element) => element.name === 'iframe'
      );
      if (iframes.length === 1) {
        return (
          <IFrameSafe
            {...iframes[0].attribs}
            sandbox={defaultSandbox + ' allow-presentation allow-same-origin'}
          />
        );
      }

      return (
        <IFrameSafe
          src={'data:text/html,' + encodeURIComponent(html)}
          sandbox={defaultSandbox}
        />
      );
    },
  };

  //added <div></div> to set the loop on the first depth only
  return <>{parse('<div>' + html + '</div>', options)}</>;
}
